<template>
  <div class="gap-general var-style">
    <!-- <PreloaderPage /> -->

    <SmallBanner
      :icon="'contract'"
      :title="$t('forex-contract-specs.title')"
      :description="$t('forex-contract-specs.description')"
    />

    <div class="margin-general find_forex margin-less">
      <TabsTable
        :tabs="tabs"
        :categories="categories"
        
        class="var-special"
      />
    </div>

    <client-only>
      <LazyInvestment
        class="investment var-invest-two"
        :label="'forex-contract-specs.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'forex-contract-specs.btn'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import SmallBanner from "~/components/SmallBanner.vue";
import TabsTable from "~/components/forex/tabsTable.vue";

import { useI18n } from "vue-i18n";
const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();
const title = t("seo.trading-conditions.forex.contract-specs.title");
const description = t(
  "seo.trading-conditions.forex.contract-specs.description"
);

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
});

const tabs = ref([
  { value: "forex", label: "forex-contract-specs.labeltab1" },
  { value: "metails", label: "forex-contract-specs.labeltab2" },
  { value: "crypto", label: "forex-contract-specs.labeltab3" },
  { value: "indices", label: "forex-contract-specs.labeltab4" },
  { value: "commodites", label: "forex-contract-specs.labeltab5" },
]);

const categories = ref({
  forex: [
    {
      titleCards: {
        title: [
          { text: "forex-contract-specs.subtitle1" },
          { text: "forex-contract-specs.subtitle2" },
          { text: "forex-contract-specs.subtitle3" },
          {
            class: "more-item",
            text: "forex-contract-specs.subtitle4",
            optionalDiv: [{ text: "forex-contract-specs.subtitle5" }, { text: "forex-contract-specs.subtitle6" }],
          },
        ],
      },
      cards: [
        {
          items: [
            { column1: "AUDCAD" },
            { column1: "Australian Dollar / Canadian Dollar" },
            { column1: "$7.64" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "AUDCHF" },
            { column1: "Australian Dollar / Swiss Franc" },
            { column1: "$10.52" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "AUDJPY" },
            { column1: "Australian Dollar / Japanese Yen" },
            { column1: "$9.45" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "AUDNZD" },
            { column1: "Australian Dollar / New Zealand Dollar" },
            { column1: "$7.23" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "AUDUSD" },
            { column1: "Australian Dollar / US Dollar" },
            { column1: "$10.00" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "CADCHF" },
            { column1: "Canadian Dollar / Swiss Franc" },
            { column1: "$10.52" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "CADJPY" },
            { column1: "Canadian Dollar / Japanese Yen" },
            { column1: "$9.45" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "CHFJPY" },
            { column1: "Swiss Franc / Japanese Yen" },
            { column1: "$9.45 " },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURAUD" },
            { column1: "Euro / Australian Dollar" },
            { column1: "$7.75" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURCAD" },
            { column1: "Euro / Canadian Dollar" },
            { column1: "$7.64" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURCHF" },
            { column1: "Euro / Swiss Franc" },
            { column1: "$10.52" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURCZK" },
            { column1: "Euro / Czech Koruna" },
            { column1: "$0.49" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURDKK" },
            { column1: "Euro / Danish Krone" },
            { column1: "$1.65" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURGBP" },
            { column1: "Euro / Great Britain Pound" },
            { column1: "$13.97" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURHKD" },
            { column1: "Euro / Hong Kong Dollar" },
            { column1: "$1.28" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURHUF" },
            { column1: "Euro / Hungarian Forint" },
            { column1: "$3.96" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURJPY" },
            { column1: "Euro / Japanese Yen" },
            { column1: "$9.46" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURNOK" },
            { column1: "Euro / Norwegian Krone" },
            { column1: "$1.30" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURNZD" },
            { column1: "Euro / New Zealand Dollar" },
            { column1: "$7.24" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURPLN" },
            { column1: "Euro / Polish Zloty" },
            { column1: "$2.92" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURUSD" },
            { column1: "Euro / US Dollar" },
            { column1: "$10.00" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURSGD" },
            { column1: "Euro / Singapore Dollare" },
            { column1: "$7.61" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURSEK" },
            { column1: "Euro / Swedish Krona" },
            { column1: "$1.22" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURTRY" },
            { column1: "Euro / Turkish Lira" },
            { column1: "$2.56" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "EURZAR" },
            { column1: "Euro / South African Rand" },
            { column1: "$0.84" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPAUD" },
            { column1: "Great Britain Pound / Australian Dollar" },
            { column1: "$7.77" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPCAD" },
            { column1: "Great Britain Pound / Canadian Dollar" },
            { column1: "$7.65" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPCHF" },
            { column1: "Great Britain Pound / Swiss Franc" },
            { column1: "$10.53" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPDKK" },
            { column1: "Great Britain Pound / Danish Krone" },
            { column1: "$1.65" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPHKD" },
            { column1: "Great Britain Pound / Hong Kong Dollar" },
            { column1: "$1.28" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPJPY" },
            { column1: "Great Britain Pound / Japanese Yen" },
            { column1: "$9.46" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPNOK" },
            { column1: "Great Britain Pound / Norwegian Krone" },
            { column1: "$1.30" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPNZD" },
            { column1: "Great Britain Pound / New Zealand Dollar" },
            { column1: "$7.24" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPSEK" },
            { column1: "Great Britain Pound / Swedish Krona" },
            { column1: "$1.22" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPSGD" },
            { column1: "Great Britain Pound / Singapore Dollare" },
            { column1: "$7.61" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GBPUSD" },
            { column1: "Great Britain Pound / US Dollar" },
            { column1: "$10.00" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NOKJPY" },
            { column1: "Norwegian Krone / Japanese Yen" },
            { column1: "$0.09" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NOKSEK" },
            { column1: "Norwegian Krone / Swedish Krona" },
            { column1: "$0.04" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NZDCAD" },
            { column1: "New Zealand Dollar / Canadian Dollar" },
            { column1: "$7.65" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NZDCHF" },
            { column1: "New Zealand Dollar / Swiss Franc" },
            { column1: "$10.53" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NZDJPY" },
            { column1: "New Zealand Dollar / Japanese Yen" },
            { column1: "$9.46" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NZDUSD" },
            { column1: "New Zealand Dollar / US Dollar" },
            { column1: "$10.00" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDCAD" },
            { column1: "US Dollar / Canadian Dollar" },
            { column1: "$7.65" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDCHF" },
            { column1: "US Dollar / Swiss Franc" },
            { column1: "$10.53" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDCNH" },
            { column1: "US Dollar / Offshore Chinese Renminbi" },
            { column1: "$1.58" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDCZK" },
            { column1: "US Dollar / Czech Koruna" },
            { column1: "$0.49" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDDKK" },
            { column1: "US Dollar / Danish Krone" },
            { column1: "$1.65" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDHKD" },
            { column1: "US Dollar / Hong Kong Dollar" },
            { column1: "$1.28" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDHUF" },
            { column1: "US Dollar / Hungarian Forint" },
            { column1: "$3.96" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDILS" },
            { column1: "US Dollar / Israeli New Shekel" },
            { column1: "$2.89" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDJPY" },
            { column1: "US Dollar / Japanese Yen" },
            { column1: "$9.46" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDNOK" },
            { column1: "US Dollar / Norwegian Krone" },
            { column1: "$1.30" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDMXN" },
            { column1: "US Dollar / Mexican Peso" },
            { column1: "$0.53" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDPLN" },
            { column1: "US Dollar / Polish Zloty" },
            { column1: "$2.92" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDSEK" },
            { column1: "US Dollar / Swedish Krona" },
            { column1: "$1.22" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDSGD" },
            { column1: "US Dollar / Singapore Dollare" },
            { column1: "$7.61" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDTHB" },
            { column1: "US Dollar / Thai Baht" },
            { column1: "$32.06" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDTRY" },
            { column1: "US Dollar / Turkish Lira" },
            { column1: "$2.56" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDRUB" },
            { column1: "US Dollar / Russian Ruble" },
            { column1: "$0.17" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "USDZAR" },
            { column1: "US Dollar / South African Rand" },
            { column1: "$0.84" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
      ],
    },
  ],
  metails: [
    {
      titleCards: {
        title: [
          { text: "Ticker" },
          { text: "Name" },
          { text: "PIP Value per lot (100K)*" },
          {
            class: "more-item",
            text: "Trading session",
            optionalDiv: [{ text: "Open" }, { text: "Close" }],
          },
        ],
      },
      cards: [
        {
          items: [
            { column1: "XAGUSD" },
            { column1: "Silver / US Dollar" },
            { column1: "$10.00" },
            { column1: "01:00:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "XAUUSD" },
            { column1: "Gold / US Dollar" },
            { column1: "$10.00" },
            { column1: "01:00:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "XAUEUR" },
            { column1: "Gold / Euro" },
            { column1: "$12.30" },
            { column1: "01:00:00", column2: "23:59:00", class: "more-item" },
          ],
        },
      ],
    },
  ],
  crypto: [
    {
      titleCards: {
        title: [
          { text: "Ticker" },
          { text: "Name" },
          { text: "PIP Value per lot (100K)*" },
          {
            class: "more-item",
            text: "Trading session",
            optionalDiv: [{ text: "Open" }, { text: "Close" }],
          },
        ],
      },
      cards: [
        {
          items: [
            { column1: "BTCUSD" },
            { column1: "Bitcoin / US Dollar" },
            { column1: "$10" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "ETHUSD" },
            { column1: "Ethereum / US Dollar CFD" },
            { column1: "$10" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "LTCUSD" },
            { column1: "Litecoin / US Dollar CFD" },
            { column1: "$10" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "XPRUSD" },
            { column1: "Ripple / US Dollar CFD" },
            { column1: "$10" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "BTCJPY" },
            { column1: "Bitcoin / Japanese  Yen CFD" },
            { column1: "$10" },
            { column1: "00:05:00", column2: "23:59:00", class: "more-item" },
          ],
        },
      ],
    },
  ],
  indices: [
    {
      titleCards: {
        title: [
          { text: "Ticker" },
          { text: "Name" },
          { text: "PIP Value per lot (100K)*" },
          {
            class: "more-item",
            text: "Trading session",
            optionalDiv: [{ text: "Open" }, { text: "Close" }],
          },
        ],
      },
      cards: [
        {
          items: [
            { column1: "WS30" },
            { column1: "Dow Jones" },
            { column1: "$1" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "SPXm " },
            { column1: "S&P 500" },
            { column1: "$1" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "K100" },
            { column1: "TSE" },
            { column1: "$1.39" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NDX" },
            { column1: "Nasdaq" },
            { column1: "$1" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "FCHI" },
            { column1: "French Cac 40" },
            { column1: "$1.23" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "STOXX50E" },
            { column1: "Euro Stoxx 50" },
            { column1: "$1.23" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "GDAXI" },
            { column1: "German Index" },
            { column1: "$1.23" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "J225" },
            { column1: "Japan Nikkei" },
            { column1: "$0.09" },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "AUS200" },
            { column1: "Australian ASX" },
            { column1: "$0.77 " },
            { column1: "01:00:00", column2: "23:00:00", class: "more-item" },
          ],
        },
      ],
    },
  ],
  commodites: [
    {
      titleCards: {
        title: [
          { text: "Ticker" },
          { text: "Name" },
          { text: "PIP Value per lot (100K)*" },
          {
            class: "more-item",
            text: "Trading session",
            optionalDiv: [{ text: "Open" }, { text: "Close" }],
          },
        ],
      },
      cards: [
        {
          items: [
            { column1: "CRUDEOIL" },
            { column1: "US Crude Oil" },
            { column1: "$1" },
            { column1: "01:00:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "UKOIL" },
            { column1: "UK Brent Oil" },
            { column1: "$1" },
            { column1: "01:00:00", column2: "23:59:00", class: "more-item" },
          ],
        },
        {
          items: [
            { column1: "NGAS" },
            { column1: "US Natural Gas " },
            { column1: "$1" },
            { column1: "01:00:00", column2: "23:59:00", class: "more-item" },
          ],
        },
      ],
    },
  ],
});
</script>
